import { NavLink, useNavigate, useParams, } from 'react-router-dom';
import { hoverSidebar } from '../../redux/slices/sidebarslice';
import { AuthLogout } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from 'react-redux';
import { BiLogOutCircle } from "react-icons/bi";
import { useTranslation } from 'react-i18next';
import { IoMdConstruct } from "react-icons/io";
import Images from '../../assets/js/images';
import { FaCar } from "react-icons/fa";
import { Nav } from 'react-bootstrap';
import { Fragment } from 'react';

const Sidebar = ({ user }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { type, id } = useParams()
  const path = window.location.pathname;
  const { hover } = useSelector(state => state.SidebarSlice);

  const handleLogout = (id) => {
    dispatch(AuthLogout({ id: id, navigate }));
    dispatch({ type: "LOGOUT", payload: "" });
  }

  const checkUrl = (npath) => {
    return path.startsWith(npath) ? 'mm-active' : '';
  }

  return (
    <Fragment>
      <div className="sidebar-wrapper" data-simplebar="true" onMouseEnter={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }} onMouseLeave={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }}>
        <div className="sidebar-header justify-content-center">
          <div>
            <img src={Images?.AdminLogo} className="logo-icon" alt="logo icon" />
          </div>
        </div>
        <Nav as="ul" className="metismenu" id="menu">
          <Nav.Item as="li">
            <NavLink to={`${user?.role === 'partner' ? '/partner/dashboard' : user?.role === 'insurance' ? '/insurance' : '/admin/dashboard'}`} className={({ isActive, isPending, }) =>
              isPending ? "pending" : isActive ? "mm-active" : ""
            }>
              <div className="parent-icon">
                <svg width="1em" height="1em" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.25 8C2.25 8.41423 2.58579 8.75 3 8.75H9C9.41423 8.75 9.75 8.41423 9.75 8V3.5C9.75 3.08579 9.41423 2.75 9 2.75H3C2.58579 2.75 2.25 3.08579 2.25 3.5V8ZM8.25 15.5C8.25 15.9142 8.58577 16.25 9 16.25H15C15.4142 16.25 15.75 15.9142 15.75 15.5V11C15.75 10.5858 15.4142 10.25 15 10.25H9C8.58577 10.25 8.25 10.5858 8.25 11V15.5ZM9.75 11.75H14.25V14.75H9.75V11.75ZM2.25 15.5C2.25 15.9142 2.58579 16.25 3 16.25H6C6.41422 16.25 6.75 15.9142 6.75 15.5V11C6.75 10.5858 6.41422 10.25 6 10.25H3C2.58579 10.25 2.25 10.5858 2.25 11V15.5ZM3.75 14.75V11.75H5.25V14.75H3.75ZM3.75 7.25V4.25H8.25V7.25H3.75ZM15 8.75C15.4142 8.75 15.75 8.41423 15.75 8V3.5C15.75 3.08579 15.4142 2.75 15 2.75H12C11.5858 2.75 11.25 3.08579 11.25 3.5V8C11.25 8.41423 11.5858 8.75 12 8.75H15ZM14.25 7.25H12.75V4.25H14.25V7.25Z" fill="currentColor" />
                </svg>
              </div>
              <div className="menu-title">{t('dashboard')}</div>
            </NavLink>
          </Nav.Item>
          {(user?.role === 'partner') &&
            <>
              <Nav.Item as="li">
                <NavLink to="/partner/bookings/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/bookings/${type}`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-calendar'></i>
                  </div>
                  <div className="menu-title">{t('bookings')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/drivers" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/driver/profile/${id}`) || checkUrl(`/partner/driver/edit/${id}`)}`

                }>
                  <div className="parent-icon"><i><FaCar /></i>
                  </div>
                  <div className="menu-title">{t('drivers_text')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/mechanics" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/mechanics`)}`

                }>
                  <div className="parent-icon"><i><IoMdConstruct /></i>
                  </div>
                  <div className="menu-title">{t('mechanics_text')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/driver/trips" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/driver/trips`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-user'></i>
                  </div>
                  <div className="menu-title">{t('driver_trips')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/earnings/total_earning" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/earnings/total_earning`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-dashboard'></i>
                  </div>
                  <div className="menu-title">{t('earnings')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/driver/payment" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/driver/payment`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-dollar-circle'></i>
                  </div>
                  <div className="menu-title">{t('driver_payment')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/partner/withdrawal" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/partner/withdrawal`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-download'></i>
                  </div>
                  <div className="menu-title">{t('withdrawal_request')}</div>
                </NavLink>
              </Nav.Item>
            </>
          }
          <Nav.Item as="li">
            <NavLink type="button" onClick={() => { handleLogout(user?._id) }}>
              <div className="parent-icon"><i><BiLogOutCircle style={{ transform: 'rotate(180deg)' }} /></i>
              </div>
              <div className="menu-title">{t('logout')}</div>
            </NavLink>
          </Nav.Item>
        </Nav>
      </div>
    </Fragment >
  )
}

export default Sidebar;